module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"readMore":"Mehr lesen"},"en":{"readMore":"Read more"},"it":{"readMore":""},"lt":{"readMore":"Skaityti daugiau"},"pl":{"readMore":"Pokaż więcej"}}')
  delete Component.options._Ctor
}
